// Port of api/fuel/app/classes/filter/search/games/rules/query/play_duration.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'play_duration',
	field: function() { return 'p.play_length' }
})
